<template>
    <div v-if="!isMobile || (isMobile && current_room.id)" :class="'current-chat-wrapper ' + (isMobile ? 'is-mobile' : '')">
        <div
            v-if="currentRoom.users"
            class="current-chat-header"
        >
            <div v-if="isMobile">
                <font-awesome-icon
                    @click="handlerBack()"
                    class="icon"
                    :style="{ color: '#4663AB', fontSize: '20px', width: '30px' }"
                    icon="arrow-left"
                />
            </div>

            <div
                class="user-img"
                v-for="(user, index) in currentRoom.users"
                :key="index"
                :style="`background-image: url(${user.avatar})`"
            ></div>
            <div class="user-info">
                <div v-if="currentRoom.users.length < 3">
                    <div class="user-name"
                         v-for="(user, index) in currentRoom.users"
                         :key="index"
                    >
                        {{user.name}}
                        {{user.surname}}
                        <span v-if="index != currentRoom.users.length-1">,</span>
                    </div>
                </div>
                <div v-else>
                    Комната
                </div>
            </div>
        </div>
        <div class="chat" ref="chatScroll">
            <div
                class="chat-message"
                v-for="(item, index) in room_messages_data"
                :key="index"
                :class="{ self_chat_message: user.id == item.author }"
            >
                <div class="user-avatar">
                    <div
                        class="user-img"
                        v-if="userAvatarCheck(index)"
                        :style="`background-image: url(${(currentRoom.users.find((itm)=>{
                            return itm.id == item.author
                        }) || {}).avatar || user_img_stub})`"
                    ></div>
                </div>
                <div
                    class="user-message"
                    :class="{ self_user_message: user.id == item.author }"
                >
                    <message :text="item.payload"/>
                </div>
                <div class="message-time">
                    {{item.date | timestampTime}}
                </div>
            </div>
        </div>
        <div class="message">
            <div class="message-wrapper">
                <textarea
                    :class="{ disable: !currentRoom.users }"
                    class="message-input"
                    placeholder="Текст сообщения"
                    v-model="message"
                    @keydown="messageEnter"
                ></textarea>
                <div class="send-btn">
                    <font-awesome-icon
                        @click="sendMessage"
                        class="icon"
                        icon="paper-plane"
                    ></font-awesome-icon>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { send } from '../../../tools/ws_chat.js';

import { mapActions, mapGetters } from 'vuex';
import Message from "./message/Message";


const actions = [
    'set_current_room',
];

const getters = [
    'isMobile',
    'current_room',
    'room_messages_data',
    'user',
    'user_img_stub',
];

export default {
    name: 'CurrentChat',
    components: {Message},
    data() {
        return {
            message: '',
            prevKeyBrn: '',
        };
    },
    methods: {
        ...mapActions(actions),
        userAvatarCheck(index) {
            const currentAuthor = this.room_messages_data[index].author;

            const prevAuthor = this.room_messages_data[index - 1]
                ? this.room_messages_data[index - 1].author
                : null;

            const isMine = currentAuthor == this.user.id;
            const isTrailing = currentAuthor == prevAuthor;

            return !isMine && !isTrailing;
        },
        messageEnter(event) {
            const canSend = (event.key == 'Enter' && this.prevKeyBrn !== 'Shift') && event.target.value.trim();

            this.prevKeyBrn = event.key;

            if (!canSend) return;

            event.preventDefault();
            this.sendMessage();
            this.prevKeyBrn = '';
        },
        sendMessage(event) {
            send('new_message', {
                message_type: 'text',
                payload: this.message,
                room_id: this.currentRoom.id,
            });

            this.message = '';
        },
        handlerBack() {
            this.set_current_room({});
        },
    },
    computed: {
        ...mapGetters(getters),
    },
    watch: {
        currentRoom: function () {
            send('get_room_messages', { room_id: this.currentRoom.id });
        },
        room_messages_data: function () {
            const cb = () => this.$refs.chatScroll.scrollTop =
                this.$refs.chatScroll.scrollHeight;

            this.$nextTick(cb);
        },
    },
    props: {
        currentRoom: Object,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    @mixin custom-scroll-bar {
        &::-webkit-scrollbar {
            height: auto;
            width: 0.3rem;
        }

        &::-webkit-scrollbar-thumb {
            background: #E1E1E1;
            border-radius: 0.3rem;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }
    }

    $chat-border-grid: rem(1) solid #F2F2F2;

    .current-chat-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1;

        .current-chat-header {
            padding: 1.4rem;
            border-bottom: $chat-border-grid;
            display: flex;
            flex-direction: row;
            align-items: center;

            .user-info {
                padding-left: 0.7rem;
                display: flex;
                flex-direction: row;
                max-width: 10em;
                overflow: hidden;

                .user-name {
                    font-size: 0.6rem;
                    font-weight: 600;
                }

                .last-seen {
                    font-size: 0.55rem;
                    font-weight: 300;
                    color: #97A4BA;
                    margin-top: 0.3rem;
                }
            }

            .user-img {
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
                border-radius: 50%;
                height: 1.8rem;
                width: 1.8rem;
            }
        }
    }

    .chat {
        @include custom-scroll-bar;

        flex: 1;
        font-size: 0.7rem;
        padding: 1.4rem;
        overflow-y: scroll;

        .chat-message {
            display: flex;
            flex-direction: row;
            margin-bottom: 0.7rem;

            &.self_chat_message {
                justify-content: flex-end;
            }

            .user-avatar {
                width: 2rem;
                height: 2rem;

                .user-img {
                    background-size: cover;
                    background-position: center center;
                    background-repeat: no-repeat;
                    border-radius: 50%;
                    height: 1.8rem;
                    width: 1.8rem;
                }
            }

            .user-message {
                max-width: 80%;
                word-break: break-all;

                &.self_user_message {
                    background: #4663AB;
                    color: white;
                }

                background: #F2F2F2;
                border-radius: 0.25rem;
                padding: 0.7rem;
            }

            .message-time {
                display: flex;
                align-items: center;
                margin-left: 0.5rem;
                color: grey;
                font-size: 0.55rem;
            }
        }
    }

    .message {
        width: 100%;
        padding: 1.4rem;

        .message-wrapper {
            width: 100%;
            border: $chat-border-grid;
            border-radius: 0.3rem;
            padding: 0.7rem;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .message-input {
            width: 100%;
            font-size: 0.7rem;
            resize: none;
            height: 2rem;
            border: none;
            flex: 1;
            max-height: 10rem;

            &.disable {
                pointer-events: none;
            }

            @include custom-scroll-bar;
        }

        .send-btn {
            width: 2rem;
            height: 2rem;
            font-size: 1.2rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            > * {
                color: #006CCE;
            }
        }
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .current-chat-wrapper {
            padding: mrem(10);

            .current-chat-header {
                padding: 1.4rem;
                border-bottom: $chat-border-grid;
                display: flex;
                flex-direction: row;
                align-items: center;

                .user-info {
                    padding-left: 0.7rem;
                    display: flex;
                    flex-direction: row;
                    max-width: 100%;
                    overflow: hidden;

                    .user-name {
                        font-size: mrem(14);
                    }

                    .last-seen {
                        font-size: mrem(12);
                        font-weight: 300;
                        color: #97A4BA;
                        margin-top: 0.3rem;
                    }
                }

                .user-img {
                    height: mrem(40);
                    width: mrem(40);
                }
            }
        }

        .chat {
            .chat-message {
                display: flex;
                flex-direction: row;
                margin-bottom: 0.7rem;

                &.self_chat_message {
                    justify-content: flex-end;
                }

                .user-avatar {
                    width: mrem(40);
                    height: mrem(40);

                    .user-img {
                        background-size: cover;
                        background-position: center center;
                        background-repeat: no-repeat;
                        border-radius: 50%;
                        height: mrem(40);
                        width: mrem(40);
                    }
                }

                .user-message {
                    max-width: 80%;
                    word-break: break-all;
                    font-size: mrem(12);

                    &.self_user_message {
                        background: #4663AB;
                        color: white;
                    }

                    background: #F2F2F2;
                    border-radius: mrem(5);
                    padding: mrem(10);
                }

                .message-time {
                    display: flex;
                    align-items: center;
                    margin-left: mrem(10);
                    color: grey;
                    font-size: mrem(12);
                }
            }
        }

        .message {
            width: 100%;
            padding: 1.4rem;

            .message-wrapper {
                width: 100%;
                border: $chat-border-grid;
                border-radius: 0.3rem;
                padding: mrem(10);
                display: flex;
                flex-direction: row;
                align-items: center;

                border: 1px solid #D2D5D9;
            }

            .message-input {
                width: 100%;
                font-size: mrem(12);
                resize: none;
                height: mrem(30);
                border: none;
                flex: 1;
                max-height: mrem(60);

                &.disable {
                    pointer-events: none;
                }

                @include custom-scroll-bar;
            }

            .send-btn {
                width:mrem(25);
                height: mrem(25);
                font-size: mrem(20);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                > * {
                    color: #006CCE;
                }
            }
        }
    }
    .message-input {
        font-family: 'Open Sans', sans-serif;;
    }
</style>
